import { CdkVirtualScrollViewport } from "@angular/cdk/scrolling";
import { Component, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { NgxSpinnerService } from "ngx-spinner";
import {
  CommonDetails,
  CardDetails
} from "../../models/common-details.model";
import { GeneralDataService } from "../../services/general-data.service";
import { DashboardDataSource } from "./general-data-source";
import { environment } from "../../../../../../src/environments/environment";
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import {CompanyDialogComponent} from "../company-dialog/company-dialog.component";

@Component({
  selector: "app-reg-table",
  templateUrl: "./reg-table.component.html",
  styleUrls: ["./reg-table.component.css"],
})
export class RegTableComponent implements OnInit {
  generalDetails: DashboardDataSource;
  imageSrc;
  searchByName: string = null;
  totalSuppliers: number;
  gigaGuru: number;
  sparkingChange: number;
  TotalSuppliers = "Total Suppliers";
  SparkingChange = "Sparking Change";
  Gigaguru = "Giga Guru";
  GigaguruTooltip = CardDetails.gigaguruTooltip;
  SparkingChangeTooltip = CardDetails.sparkingChangeTooltip;
  gigaguruIcon = "assets/images/W-GIGA-GURU_25.png";
  TotalSuppliersIcon = "assets/images/reg-user-icon.png";
  sparkingChangeIcon = "assets/images/W-SPARKING-CHANGE_25.png";
  public loginURL = environment.sustainablityLoginUrl;
  public companyName: string;
  public companyLogo;
  public companyStatus: string;
  public inProgress: boolean = false;
  @ViewChild("companyDetailPopupTemplate")
  companyDetailPopupTemplateRef: TemplateRef<CompanyDialogComponent>;

  @ViewChild(CdkVirtualScrollViewport) virtualScroll: CdkVirtualScrollViewport;
  constructor(
    private readonly generalService: GeneralDataService,
    private readonly sanitizer: DomSanitizer,
    private readonly spinner: NgxSpinnerService,
    public dialog: MatDialog
  ) {}

  ngOnInit() {
    this.generalDetails = new DashboardDataSource(
      this.generalService,
      this.spinner
    );
    this.commonDetails();
  }

  ngOnDestroy(): void {
    if (this.generalDetails) {
      this.generalDetails.onDestroy();
    }
  }

  public imageSource(file: any): string {
    if (file && file !== "NULL") {
      this.imageSrc = this.sanitizer.bypassSecurityTrustResourceUrl(
        "data:image/png;base64," + file //nosonar
      );
      return this.imageSrc;
    } else {
      this.imageSrc = "default";
      return null;
    }
  }
  public searchSupplier(): void {
    if (this.searchByName && this.generalDetails.isLoaded) {
      this.generalDetails.getDetails("initial", this.searchByName);
    }
  }
  public clearSearchResult(inputData): void {
    if (!inputData) {
      this.searchByName = null;
      this.generalDetails.getDetails("initial", this.searchByName);
    }
  }
  private commonDetails() {
    this.generalService.getCommonData().subscribe((value) => {
      this.totalSuppliers = value[CommonDetails.totalSupplier];
      this.gigaGuru = value[CommonDetails.gigaGuru];
      this.sparkingChange = value[CommonDetails.sparkingChange];
    });
  }

  public openCompanyDetailsDialog(details) {
    this.companyName = details.companyName;
    this.companyStatus = details.gigaGuru;
    this.companyLogo = this.imageSource(details.logo);
    this.dialog.open(this.companyDetailPopupTemplateRef, {
      autoFocus: false,
      disableClose: false,
    });
  }
}
